import axios from '@/libs/api.request'

export const login = ({ username, password }) => {
  const data = {
    name: username,
    password: password
  }
  return axios.request({
    // url: 'UtilERP/user/verify',
    url: 'user/verify',

    params: data,
    method: 'get'
  })
}

export const getUserInfo = (token) => {
  return axios.request({
    url: 'get_info',
    params: {
      token
    },
    method: 'get'
  })
}

export const logout = (token) => {
  return axios.request({
    url: 'logout',
    method: 'post'
  })
}
